import Vue from 'vue'
const formDesign = {
  state: {
    isDisable: false,
  },
  mutations: {
    SET_DISABLE(state, record) {
      state.isDisable = record
    }
  },
  actions: {
    setDisable({ commit }, record) {
      commit('SET_DISABLE', record)
    },
  },
  getters:{
    isDisable: state => state.isDisable,
  }
}
export default formDesign
